import { useCallback, useEffect, useState } from "react";

const DEFAULT_DISPLAY_TEXT = "Upload Records / Bills";
const DISABLED_TEXT= "Provider Name Already Exists";
const BORDER_TEXT = "Upload Medical Records / Bills";


export default function useMedicalButton(isBorder, getIsDuplicateProviderNameCallback) {
    const [buttonDisplayText, setDisplayText] = useState(DEFAULT_DISPLAY_TEXT);
    const [isButonDisabled, setButonDisabled] = useState(false); // if provider name is same then disable field

    useEffect(()=>{
        if(isBorder){
            if(isButonDisabled){
                setDisplayText(DISABLED_TEXT);
            }
            else{
                setDisplayText(BORDER_TEXT);
            }
        }
        else{
            setDisplayText(DEFAULT_DISPLAY_TEXT);
        }
    }, [isBorder, isButonDisabled]);

    const checkProviderName = useCallback((currentValue, index) => {
        if (getIsDuplicateProviderNameCallback(currentValue, index)) {
            setButonDisabled(true);
        } else {
            setButonDisabled(false);
        }
    }, [getIsDuplicateProviderNameCallback]);
    
    return {
        buttonDisplayText,
        isButonDisabled,
        checkProviderName,
    };
}